import React, { useState, useEffect } from "react";
import { Form, Modal, Button, Spinner, Alert } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext";

const API_URL = process.env.REACT_APP_API_URL || "https://apiprov.conduto.com.ec";

const FinishStep = ({ formData, prevStep, type, idFormulario }) => {
  const [accepted, setAccepted] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [accionistas, setAccionistas] = useState([]);
  const [cargandoAccionistas, setCargandoAccionistas] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const cargarAccionistas = async () => {
      if (!idFormulario) {
        setCargandoAccionistas(false);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${API_URL}/api/providers/accionistas/${idFormulario}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            credentials: "include",
          }
        );

        if (response.ok) {
          const data = await response.json();
          setAccionistas(data);
        }
      } catch (err) {
        console.error("Error al cargar accionistas:", err);
      } finally {
        setCargandoAccionistas(false);
      }
    };

    cargarAccionistas();
  }, [idFormulario]);

  const finalizarFormulario = async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");

      const resFormulario = await fetch(
        `${API_URL}/api/formularios/activo`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          credentials: "include",
        },
      );

      if (!resFormulario.ok) throw new Error("Error al obtener formulario");
      const formulario = await resFormulario.json();
      if (!formulario) throw new Error("No se encontró formulario activo");

      const resVerificar = await fetch(
        `${API_URL}/api/formularios/${idFormulario}/estado-acceso`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        }
      );

      if (resVerificar.ok) {
        const estadoAcceso = await resVerificar.json();
        if (!estadoAcceso.acceso_permitido) {
          throw new Error(estadoAcceso.motivo_bloqueo);
        }
      }

      const resFinalizar = await fetch(
        `${API_URL}/api/formularios/${idFormulario}/completar`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
          body: JSON.stringify({
            estado: "finalizado",
            datos_proveedor: formData,
          }),
        },
      );

      if (!resFinalizar.ok) {
        const errorData = await resFinalizar.json().catch(() => ({}));
        throw new Error(
          errorData.detail || errorData.error || `Error al finalizar formulario: ${resFinalizar.status}`
        );
      }

      const resEncolar = await fetch(
        `${API_URL}/api/formularios/${idFormulario}/encolar-sharepoint`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        },
      );

      if (resEncolar.ok) {
        const dataEncolar = await resEncolar.json();
      } else {
        console.warn(
          "Advertencia: No se pudieron encolar archivos para SharePoint",
        );
      }

      await fetch(
        `${API_URL}/api/formularios/${idFormulario}/notificar-terminado`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        },
      );

      const resUpdateUser = await fetch(
        `${API_URL}/api/documentos/usuarios/${user.id_usuario}/ultima-ruta`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
          body: JSON.stringify({ ultima_ruta: null }),
        },
      );

      if (!resUpdateUser.ok) {
        const errorData = await resUpdateUser.json().catch(() => ({}));
        console.warn(
          "Advertencia: Error al actualizar última ruta:",
          errorData.error,
        );
      }

      setShowSuccessModal(true);
    } catch (err) {
      setError(err.message);
      console.error("Error al finalizar formulario:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    window.location.href = "https://proveedores.conduto.com.ec/proveedor/form";
  };

  const handleAnterior = async () => {
    const pathParts = location.pathname.split("/");
    const currentStep = parseInt(pathParts[pathParts.length - 1], 10);
    const prevStepNumber = currentStep - 1;
    const newRoute = `/form/${type}/${prevStepNumber}${idFormulario ? `?id_formulario=${idFormulario}` : ""}`;

    try {
      const token = localStorage.getItem("token");

      await fetch(
        `${API_URL}/api/formularios/${idFormulario}/ultima-ruta`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
          body: JSON.stringify({ ultima_ruta: newRoute }),
        },
      );

      navigate(newRoute);
    } catch (err) {
      console.error("Error al actualizar la ruta:", err);
      navigate(newRoute);
    }
  };

  if (cargandoAccionistas) {
    return (
      <div className="p-4 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Cargando información de accionistas...</p>
      </div>
    );
  }

  return (
    <div className="p-4 container">
      <div className="mb-4 text-justify">
        <h2 className="alert-heading">Declaración de información</h2>
        <h5>Declaración de Licitud de Fondos</h5>

        <p>
          Declaro que las transacciones y operaciones que he efectuado o efectuaré con CONDUTO ECUADOR S.A. tienen procedencia lícita, no ligada con actividades de narcotráfico, lavado de dinero o cualquier otra actividad inusual tipificada en la “Ley de Prevención, Detección y Erradicación del Delito de Lavado de Activos y de Financiamiento de Delitos”.
        </p>

        {console.log("FormData en FinishStep:", user)}

        {(user?.tipo_persona !== "natural") && (
          <>

            <h5>Declaración de Beneficiario Final </h5>

            <p>Yo, {formData?.providerInfo?.representante_legal || formData?.providerInfo?.razon_social || "[Nombre completo]"}, representante legal de la compañía {formData?.providerInfo?.razon_social || "[Razón Social]"}, con RUC No. {formData?.providerInfo?.ruc || "[XXXXXXXXXX]"}, declaro bajo juramento que el/los beneficiario(s) final(es) de la sociedad son las personas naturales que, directa o indirectamente, poseen, controlan o se benefician con un porcentaje igual o superior al 25% del capital social o de los derechos de voto de la compañía.</p>

            <p>Los beneficiarios finales identificados son:</p>

            {accionistas && accionistas.length > 0 ? (

              <ul>
                {accionistas.map((accionista, index) => (
                  <>
                    <p>
                      <li key={index}>
                        <strong>Nombre completo:</strong> {accionista.nombre}<br />
                        <strong>Documento de identidad:</strong> {accionista.cedula}<br />
                        <strong>Porcentaje de participación:</strong> {accionista.porcentaje}%
                      </li>
                    </p>
                  </>
                ))}
              </ul>
            ) : (
              <ul>
                <li>Nombre completo: [Nombre del beneficiario]</li>
                <li>Documento de identidad: [Cédula/Pasaporte]</li>
                <li>Porcentaje de participación: [XX%]</li>
              </ul>
            )}
            <p>Me comprometo a mantener esta información actualizada y a reportar cualquier cambio conforme a lo dispuesto por la Superintendencia de Compañías, Valores y Seguros y la normativa vigente de prevención de lavado de activos.</p>
          </>
        )}

        <h5>Declaración de Licitud de información</h5>

        <p>Declaro que la información contenida en este formulario es verdadera, completa y confiable. <br /> Además, declaro conocer y aceptar que es mi obligación actualizar anualmente mis datos personales, así como comunicar y documentar de forma inmediata a CONDUTO ECUADOR S.A., cualquier cambio en la información durante la vigencia de la relación comercial. </p>

        <p>Me comprometo a proveer de la documentación e información que me sea solicitada y autorizo expresamente a que ésta sea verificada a través de los medios que se consideren necesarios tal como Burós de Crédito autorizados por la Superintendencia de Bancos o cualquier otro medio.</p>

        <h5>Autorización</h5>

        <p>Autorizo a Conduto Ecuador S.A. a realizar el análisis y las verificaciones que considere necesarias para corroborar la licitud de fondos y bienes comprendidos en el contrato de servicios y bienes prestados.  <br /> Así mismo autorizo el archivo, procesamiento y administración de mis datos de acuerdo a sus mejores prácticas. </p>

        <div
          className="box mt-2 p-2 text-content"
          style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #ced4da",
            borderRadius: "5px",
          }}
        >
          La información transmitida, incluidos los archivos adjuntos, está
          destinada únicamente a la(s) persona(s) o entidad a la que se dirige y
          puede contener material confidencial y/o privilegiado. Queda prohibida
          cualquier revisión, retransmisión, difusión u otro uso, o cualquier
          acción basada en esta información por parte de personas o entidades
          que no sean el destinatario previsto. Para acceder a nuestra Política
          de Tratamiento de Datos Personales{" "}
          <a
            href="https://www.conduto.com/images/dp/POLITICA-DE-TRATAMIENTO-DE-DATOS-PERSONALES.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            aquí
          </a>
          , y si desea comunicarse con nosotros tenga a su disposición el
          correo:{" "}
          <a href="mailto:datospersonales@conduto.com">
            datospersonales@conduto.com
          </a>
        </div>

        <Form.Check
          type="checkbox"
          id="veracity-check"
          label="Autorizo el tratamiento de mis datos personales a Conduto Ecuador S.A. conforme lo establecido en su política de privacidad"
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
          className="mt-3"
        />
      </div>

      {error && (
        <Alert variant="danger" className="mb-4" dismissible onClose={() => setError(null)}>
          <Alert.Heading>Error</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}

      <div className="d-flex justify-content-between mt-4">
        <Button
          variant="outline-secondary"
          onClick={handleAnterior}
          disabled={loading}
        >
          Anterior
        </Button>
        <Button
          variant="success"
          disabled={!accepted || loading}
          onClick={finalizarFormulario}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="ms-2">Procesando...</span>
            </>
          ) : (
            "Enviar Formulario"
          )}
        </Button>
      </div>

      <Modal show={showSuccessModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>¡Formulario Completado!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              fill="#28a745"
              className="bi bi-check-circle mb-3"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
            </svg>
            <h4>Formulario finalizado correctamente</h4>
            <p className="text-muted">
              Tu formulario ha sido completado y enviado para revisión. Ya no
              podrás modificarlo.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="primary" onClick={handleModalClose}>
            Continuar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FinishStep;